var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-nav-notifications-icon",on:{"click":_vm.navigate}},[_c('img',{attrs:{"src":_vm.$icons.Notifications}}),(_vm.hasUnreadMessages)?_c('span',{staticClass:"notification-dot"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }